import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/looks/new")({
  component: () => <Navigate to="/looks" replace />,
});
